// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"a95ae938","150":"68c630e1","182":"b227c9ea","247":"e90fe45a","457":"0417c152","472":"7a350e49","488":"c811b8d5","627":"ece0f520","653":"ffe62dc5","867":"08afef3c","923":"065494f0","938":"8c0196d8"}[chunkId] + ".chunk.js";
};